import { useParam } from "@blitzjs/next"
import { FC } from "react"
import { ApplicationLeftButtons, ApplicationRightButtons } from "./application/ApplicationLoader"
import { AuthenticatedHeader } from "./AuthenticatedHeader"
import { Header, HeaderProps } from "./Header"

export const ApplicationHeader: FC<HeaderProps> = ({ ...props }) => {
  const applicationId = useParam("applicationId", "number")
  if (!applicationId) {
    return <AuthenticatedHeader {...props} />
  }
  const { rightButtons, leftButtons, title, ...rest } = props
  return (
    <Header
      {...rest}
      rightButtons={
        <>
          {rightButtons}
          <ApplicationRightButtons applicationId={applicationId} />
        </>
      }
      leftButtons={
        leftButtons ? (
          <>
            <ApplicationLeftButtons
              backButtonBehavior={props.backButtonBehavior}
              backDestination={props.backDestination}
              title={title}
              applicationId={applicationId}
            />
            {leftButtons}
          </>
        ) : (
          <ApplicationLeftButtons
            backButtonBehavior={props.backButtonBehavior}
            backDestination={props.backDestination}
            title={title}
            applicationId={applicationId}
          />
        )
      }
    />
  )
}
